import { toSafeWhitespaceString as toSafeString } from '@shared/utils';
import resolveMainThreadHeaderRouteContext from '@/lib/routes/resolveMainThreadHeaderRouteContext.js';
import isOnboardingThreadType from '@/lib/threads/isOnboardingThreadType.js';
import { pathname, activeAutomationsPane } from '@/redux/selectors/uiSelectors.js';
import { threadMetaById } from '@/redux/selectors/pieveSelectors/baseSelectors.js';
import { isDraftThreadActive } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { threadContent, threadMeta } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import { threadItems, scheduleThreads, triggerThreads } from '@/redux/selectors/pieveSelectors/sidebarThreadCollectionSelectors.js';
import { currentAutomationSchedule } from '@/redux/selectors/pieveSelectors/automationScheduleSelectors.js';
import { currentAutomationTrigger } from '@/redux/selectors/pieveSelectors/automationTriggerSelectors.js';
import { currentWorkflow } from '@/redux/selectors/pieveSelectors/automationWorkflowSelectors.js';

export const mainThreadHeaderTitle = (state) => {
  const currentPathname = pathname(state);
  const currentActiveAutomationsPane = activeAutomationsPane(state);
  const currentActiveThreadId = activeThreadId(state);
  const currentRouteThreadId = isDraftThreadActive(state) ? '' : toSafeString(routeThreadId(state));

  const routeContext = resolveMainThreadHeaderRouteContext({ activeAutomationsPane: currentActiveAutomationsPane, pathname: currentPathname });
  const { isAutomationsWorkflowsView, isConnectionsView, isOrgSettingsRoute, isSchedulesView, isSettingsLikeView, isSkillsView, isTriggersView } = routeContext;

  if (isOrgSettingsRoute) {
    return 'Organization Settings';
  }
  if (isSettingsLikeView) {
    return 'Settings';
  }
  if (isConnectionsView) {
    return 'Connections';
  }
  if (isSkillsView) {
    return 'Skills';
  }

  if (isAutomationsWorkflowsView) {
    const workflow = currentWorkflow(state);
    return toSafeString(threadMeta(state, workflow?.threadId)?.title) || toSafeString(workflow?.title) || 'Workflows';
  }

  const automationRouteId = toSafeString(routeContext.automationsRouteContext?.id);
  const resolveAutomationFallbackTitle = () => {
    if (automationRouteId) {
      const scheduleThreadList = scheduleThreads(state);
      const scheduleThread = Array.isArray(scheduleThreadList) ? scheduleThreadList.find((t) => toSafeString(t?.id || t?.threadId) === automationRouteId) : null;
      if (scheduleThread?.title) {
        return toSafeString(scheduleThread.title);
      }

      const triggerThreadList = triggerThreads(state);
      const triggerThread = Array.isArray(triggerThreadList) ? triggerThreadList.find((t) => toSafeString(t?.id || t?.threadId) === automationRouteId) : null;
      if (triggerThread?.title) {
        return toSafeString(triggerThread.title);
      }

      const items = threadItems(state);
      const sidebarItem = Array.isArray(items) ? items.find((i) => toSafeString(i?.id) === automationRouteId) : null;
      if (sidebarItem?.label) {
        return toSafeString(sidebarItem.label);
      }

      const metaTitle = toSafeString(threadMetaById(state)?.[automationRouteId]?.title);
      if (metaTitle) {
        return metaTitle;
      }
    }

    return toSafeString(threadMeta(state, currentRouteThreadId || currentActiveThreadId)?.title) || toSafeString(threadMeta(state, currentActiveThreadId)?.title) || '';
  };

  if (isSchedulesView) {
    return toSafeString(currentAutomationSchedule(state)?.title) || resolveAutomationFallbackTitle() || 'New schedule';
  }

  if (isTriggersView) {
    return toSafeString(currentAutomationTrigger(state)?.title) || resolveAutomationFallbackTitle() || 'New trigger';
  }

  const headerTitle = toSafeString(threadContent(state, currentActiveThreadId)?.header?.title);
  const routeMetaTitle = toSafeString(threadMeta(state, currentRouteThreadId || currentActiveThreadId)?.title);
  const activeMetaTitle = toSafeString(threadMeta(state, currentActiveThreadId)?.title);

  if (isOnboardingThreadType(threadMeta(state, currentRouteThreadId || currentActiveThreadId)?.threadType || threadMeta(state, currentActiveThreadId)?.threadType)) {
    return 'Onboarding';
  }

  return headerTitle || routeMetaTitle || activeMetaTitle || '';
};
